import React from 'react';
import { motion } from 'framer-motion';

interface SettingsGroupProps {
    label: string;
    children: React.ReactNode;
    icon?: React.ReactNode;
    delay?: number;
}

export const SettingsGroup: React.FC<SettingsGroupProps> = ({
    label,
    children,
    delay = 0,
}) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay, duration: 0.4 }}
            className="bg-[var(--bg-elevated)] border border-[var(--border)] rounded-xl overflow-hidden"
        >
            <div className="px-4 py-3 border-b border-[var(--border)] bg-[var(--bg)]/50">
                <span className="text-[10px] font-semibold text-[var(--text-muted)] uppercase tracking-[0.06em]">
                    {label}
                </span>
            </div>
            <div className="divide-y divide-[var(--border)]">
                {children}
            </div>
        </motion.div>
    );
};